import { getApiDomain, getBaseApiPath } from "../configs";

export const BACKEND_ROUTES = {
  REDIRECT_FOLLOW: "/redirect/follow",
} as const;

export const getAbsoluteBackendEndpoint = (
  route: keyof typeof BACKEND_ROUTES,
  version = 1
) => {
  const apiPath = `${getBaseApiPath()}/v${version}`;
  const endpointPath = BACKEND_ROUTES[route];
  
  return `${getApiDomain()}${apiPath}${endpointPath}`;
};
